import { makeMnErrorView } from "common/components/error";
import { FetchErrorRetry } from "common/helpers/errors";

import { DefaultView } from "../defaultView";
import pieWidgetTemplate from "./pieView.jst";

import { pieWidgetMixin } from "./pieWidgetView";

export const PieView = DefaultView.extend().extend({
    ...pieWidgetMixin,
    type: "pie",
    template: pieWidgetTemplate,
    regions: {
        legend: ".card-list",
        chart: ".card-chart"
    },
    
    ui() {
        return {
            widgetTitle: ".pie-name",
            ...DefaultView.prototype.ui
        };
    },
    
    events: {
        "click .header": function(e) {
            e.preventDefault();
            this.drilldownToCorrespondingPage();
        },
        ...DefaultView.prototype.events
    },
    
    attributes(...args) {
        return {
            ...DefaultView.prototype.attributes.call(this, ...args),
            "gs-max-h": 6,
            "gs-min-h": 4,
            "gs-min-w": 3,
            "gs-max-w": 12
        };
    },
    
    initialize() {
        this.setDataCollection();
    },
    
    childViewEvents: {
        drilldown(child, actor) {
            this.drilldownToCorrespondingPage(actor);
        }
    },
    
    getLoadingChildren() {
        return this.ui.content.find(".pie-widget-body");
    },
    
    getChartHeight() {
        return DefaultView.getScaleCoefficient() * (this.model.get("w") >= 6 ? 300 : 170);
    },
    
    showErrorMessage() {
        this.addWidgetTitle();
        if (this.getChildView("chart")) {
            this.getChildView("chart").hideLoader();
            this.showChildView("chart", makeMnErrorView(new FetchErrorRetry({
                message: "Please refresh widget as data could not load",
                customActions: [{
                    className: "retry-widget",
                    label: "Refresh widget"
                }],
                hideDetails: true,
                custom: true
            }), true, false));
        }
    },
    
    // Called from parent gridstack:init
    onGridstackInit() {
        this.addWidgetTitle();
        this.setGroupedCollection();
        this.addChart({
            widget: this
        });
        this.addLegend();
    },
    
    onDestroy(...args) {
        DefaultView.prototype.onDestroy.call(this, ...args);
        
        this.unsetGroupedCollection();
    }
});
